import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'
import {DeleteSubsidiaryCategoryModel, SortSubsidiaryCategoryModel} from '../Model'
import {SubsidiaryCategoryModel} from '../Model/SubsidiaryCategoryModel'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const SUBSIDIARY_CATEGORY_API = `${API_URL}/subsidiary-category`

export const service = {
  getSubsidiaryCategory: (params: ParamsModel) => {
    return axios.get(SUBSIDIARY_CATEGORY_API, {params})
  },
  getAllSubsidiaryCategory: () => {
    return axios.get(`${SUBSIDIARY_CATEGORY_API}/list`)
  },

  addSubsidiaryCategory: (data: any) => {
    return axios.post(SUBSIDIARY_CATEGORY_API, data)
  },

  updateSubsidiaryCategory: (body: SubsidiaryCategoryModel, id: string) => {
    return axios.patch(`${SUBSIDIARY_CATEGORY_API}/${id}`, body)
  },

  deleteSubsidiaryCategory: (data: DeleteSubsidiaryCategoryModel) => {
    return axios.delete(SUBSIDIARY_CATEGORY_API, {data})
  },

  enableSubsidiaryCategory: (data: Array<string>) => {
    const selectedSubsidiaryCategory = {
      subsidiaryCategoryId: data,
    }
    return axios.patch(`${SUBSIDIARY_CATEGORY_API}/enable`, selectedSubsidiaryCategory)
  },

  disableSubsidiaryCategory: (data: Array<string>) => {
    const selectedSubsidiaryCategory = {
      subsidiaryCategoryId: data,
    }
    return axios.patch(`${SUBSIDIARY_CATEGORY_API}/disable`, selectedSubsidiaryCategory)
  },

  singleEnableSubsidiaryCategory: (data: Array<string>) => {
    const selectedSubsidiaryCategory = {
      subsidiaryCategoryId: [data],
    }
    return axios.patch(`${SUBSIDIARY_CATEGORY_API}/enable`, selectedSubsidiaryCategory)
  },

  singleDisableSubsidiaryCategory: (data: Array<string>) => {
    const selectedSubsidiaryCategory = {
      subsidiaryCategoryId: [data],
    }
    return axios.patch(`${SUBSIDIARY_CATEGORY_API}/disable`, selectedSubsidiaryCategory)
  },

  sortSubsidiaryCategory: (body: SortSubsidiaryCategoryModel) => {
    return axios.patch(`${SUBSIDIARY_CATEGORY_API}/sort`, body)
  },
}
